<template>
  <div>
   <admin-change-rolesandusers ref="changeApprovalUserRole" :userRoleId="mainUserRoleId" :disabled="disableEditing" :creating="creating"></admin-change-rolesandusers>
  </div>
</template>

<script>

// import router from '@/router'
// import helperMethods from '@/components/utility/helperMethods.js'
export default {
  name: 'selectApprovalUserRole',
  props: {
    userRoleId: {
      default: 0
    }
  },
  data () {
    return {
      mainUserRoleId: 0,
      approvalUserRoleValidState: false,
      disableEditing: true,
      creating: false
    }
  },
  created: function () {
    this.$on('createUserRoleValidation', function (value) {
      this.approvalUserRoleValidState = value
    })
    this.startUp()
  },
  methods: {
    startUp () {
      this.mainUserRoleId = this.userRoleId
      // creating new role so can edit
      this.disableEditing = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
